<template>

  <div class="communityHeader">
    <div class="top">

      <ul class="contentWidth clearFix">
        <li class="fc_r"
            v-if="isLogin == false">
          <a href="javascript:;"
             @click="on_tab()">登录</a>
        </li>

        <li class="fc_r photo clearFix"
            v-if="isLogin == true"
            style="position: relative; z-index: 100;">
          <img v-if="isLogin_user.headimg"
               class="fc_l photo"
               :src="isLogin_user.headimg">
          <img v-else
               class="fc_l photo"
               src="@/assets/image/community/nophoto.png">

          <span class="fc_l"
                v-if="isLogin_user.realname">{{isLogin_user.realname}}</span>
          <img class="ico"
               src="@/assets/image/community/godown.png">
          <div class="userlink">
            <a :href="`${path}user/personInfo`"><img src="@/assets/image/header/perBtn1.png"><span>个人信息</span>
            </a>

            <router-link to="/Pcenter?type=0">
              <img src="@/assets/image/header/kongjian.png"><span>我的空间</span>
            </router-link>

            <a :href="`${path}community/message.html`"><img
                   src="@/assets/image/header/perBtn2.png"><span>我的消息</span></a>
            <a :href="`${path}manu/toSinglePic`"><img src="@/assets/image/header/perBtn3.png"><span>我的投稿</span></a>
            <a :href="`${path}user/collectpage`"><img src="@/assets/image/header/perBtn4.png"><span>我的收藏</span></a>
            <a href="javascript:;"
               @click="out()"><img src="@/assets/image/header/perBtn5.png"><span>退出登录</span></a>
          </div>
        </li>
        <li class="fc_r"><a :href="`${path}manu/manuEntry`"
             target="_blank"
             class="upload">投稿</a>
        </li>
        <li class="fc_r"><a :href="`${path}`"
             class="back">返回网站</a></li>
      </ul>
    </div>
    <div class="nav of_h">
      <div class="contentWidth navcontent">
        <div class="logo fc_l"><img src="@/assets/image/community/logo_sq.png"></div>
        <ul class="menus fc_l of_h">
          <li class="fc_l">
            <router-link to="/community">发现</router-link>
          </li>

          <li class="fc_l">
            <router-link to="/communityCircle">圈子</router-link>
          </li>
          <li class="fc_l"
              v-if="isLogin == true">
            <router-link to="/user_follow">关注</router-link>
          </li>
          <!-- <li class="fc_l">
            <router-link to="/communityPhoto">影展</router-link>
          </li> -->

        </ul>
        <div class="secrch fc_r of_h">
          <input type="text"
                 class="fc_l"
                 v-model="wordtxt"
                 placeholder="请输入关键词...">
          <button type="button"
                  class="fc_l"
                  @click="searchWord()">搜索</button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { Info, ismsg, logout } from '@/utils/api/login.js'
let Base64 = require('js-base64').Base64
export default {
  inject: ['reload'],
  props: ["router_url", "userId"],
  name: "communityHeader",
  data () {
    return {
      wordtxt: "",
      loginid: this.$store.state.id,
      headimg: sessionStorage.getItem("headimg"),
      loginName: sessionStorage.getItem("realname"),
      isLogin: '',
      isLogin_user: {},
      path: this.URL.pc_url,
    }
  },
  created () {
    this.is_login();//登录方法
  },
  methods: {
    // 切换登录注册
    on_tab () {
      console.log(this.userId);
      if (this.userId && this.userId !== undefined && this.userId !== '') {
        sessionStorage.setItem('router_url', this.router_url)//地址
        sessionStorage.setItem('userId', this.userId)//用户 id
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      } else {
        sessionStorage.setItem('router_url', this.router_url)//地址
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },


    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
        // console.log(this.isLogin);
        if (this.isLogin == true) {
          this.isLogin_user = data.user
          this.ismsg();//消息
        }
        // else {
        // this.$router.push(
        //   {
        //     path: '/community',
        //   }
        // )
        // }
      })
    },

    // 消息
    async ismsg (name) {
      let { data } = await ismsg(name);
      if (data.status == 200 && data.msgNum > 0) {
        this.tips = true
      }
    },



    searchWord () {
      let txt = encodeURIComponent(this.wordtxt);
      txt = encodeURIComponent(txt);
      window.open(`https://v.jingjiribao.cn/pages/pc/searchResult/index.html?title=${txt}&type=100`);
      this.wordtxt = ""
    },
    // 退出登录
    out () {
      this.loginid = "";
      this.headimg = "";
      this.loginName = "";
      this.$store.commit('id', "");
      this.$store.commit('headimg', "");
      this.$store.commit('realname', "");
      sessionStorage.clear();
      logout().then((res) => {
        let data = res.data;
        console.log(data);
        if (data.status == 200) {
          // this.$message({
          //   message: '退出成功',
          //   type: 'success'
          // })
          this.reload()
          this.is_login();//登录方法
          sessionStorage.setItem('router_url', this.router_url)//活动详情
        }
      })
      // //清除页面所有localStorage，退出登录
      // // this.$router.push({ path: '/login/?state=' + 1 })
    },
  },
  watch: {
    '$store.state.id': function () {
      this.loginid = this.$store.state.id || sessionStorage.getItem("id");
      this.headimg = sessionStorage.getItem("headimg");
      this.loginName = sessionStorage.getItem("realname")
    }
  },
  mounted () {
    this.loginid = sessionStorage.getItem("id");
    this.headimg = sessionStorage.getItem("headimg");
    this.loginName = sessionStorage.getItem("realname")
  }
}
</script>
<style lang="scss" scoped="scoped">
div.communityHeader {
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);

  div.top {
    background: #333;
    height: 30px;

    ul {
      display: block;
      margin: 0 auto;
      li {
        display: inline-block;
        height: 30px;

        a {
          display: inline-block;
          height: 30px;
          line-height: 30px;
          padding: 0 15px;
          font-size: 14px;
          color: #fff;
        }

        a.upload {
          background: url(../../../assets/image/community/upload.png) 0 center
            no-repeat;
          padding-left: 22px;
        }

        a.back {
          background: url(../../../assets/image/community/back.png) 0 center
            no-repeat;
          padding-left: 22px;
        }
      }

      li.photo {
        padding: 0 10px;
        cursor: pointer;

        img.photo {
          display: inline-block;
          width: 24px;
          height: 24px;
          border-radius: 12px;
          margin-top: 2px;
        }
        img.ico {
          display: inline-block;
          margin-top: 14px;
          width: 10px;
          height: 6px;
          transform: rotate(0);
          transition: all 0.5s;
        }
        span {
          display: inline-block;
          width: 60px;
          height: 30px;
          line-height: 30px;
          padding: 0 5px;
          color: #fff;
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        div.userlink {
          // display: none;
          height: 0;
          overflow: hidden;
          transition: all 0.2s;
          width: 130px;
          border-radius: 5px;
          box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
          background: #fff;
          position: absolute;
          top: 30px;
          right: 0;
          a {
            display: block;
            height: 40px;
            line-height: 40px;
            border-radius: 5px;
            border-bottom: 1px #eee solid;
            overflow: hidden;
            img {
              display: inline-block;
              width: 18px;
              height: 18px;
              vertical-align: middle;
              margin-top: -32px;
            }
            span {
              height: 40px;
              line-height: 40px;
              color: #333;
            }
          }
        }
        &:hover div.userlink {
          // display: block;
          height: 244px;
        }
        &:hover img.ico {
          transform: rotate(180deg);
        }
      }
    }
  }
  .userlink a span {
    transition: all 0.3s;
  }
  .userlink a:hover span {
    color: #d7172e !important;
  }
  div.nav {
    background: #fff;
    height: 70px;

    div.navcontent {
      margin: 0 auto;

      div.logo {
        width: 232px;
        height: 32px;

        img {
          display: block;
          width: 232px;
          height: 32px;
          margin-top: 14px;
        }
      }

      ul.menus {
        display: inline-block;
        margin-top: 16px;
        padding-left: 30px;

        li {
          display: inline-block;
          height: 32px;

          a {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 16px;
            font-size: 20px;
            font-weight: bold;
          }

          a.router-link-exact-active {
            color: #c00;
          }
        }
      }

      div.secrch {
        width: 374px;
        margin-top: 15px;
        height: 38px;
        display: flex;

        input {
          display: inline-block;
          width: 284px;
          line-height: 36px;
          font-size: 14px;
          border-radius: 4px 0 0 4px;
          padding: 0 5px;
          border: 1px #d7172e solid;
          box-sizing: border-box;
        }

        button {
          display: inline-block;
          width: 78px;
          height: 100%;
          line-height: 38px;
          color: #fff;
          transition: all 1s;
          text-align: center;
          border: 0;
          font-size: 14px;
          background-image: linear-gradient(to right, #d7172e, #ff4001);
          border: 1px #d7172e solid;
          border-radius: 0 4px 4px 0;

          &:hover {
            background-image: linear-gradient(to right, #c00, #f00);
          }
        }
      }
    }
  }
}
.fc_l::placeholder{
  color: rgba(0,0,0,.25);
}
</style>



// WEBPACK FOOTER //
// src/components/community/common/communityHeader.vue